import { SxProps } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { DateTime } from 'luxon';
import { useTranslation } from 'react-i18next';

/**
 * A simple wrapper around the MUI datepicker that uses a string value instead of a date object
 */
export function StringDatePicker(props: {
  label?: string;
  onChange: (value: string) => void;
  value: string | undefined;
  inputRef?: React.Ref<HTMLInputElement>;
  error?: boolean;
  errorMessage?: string;
  disabled?: boolean;
  sx?: SxProps;
  minDate?: DateTime;
}) {
  const { t } = useTranslation();
  const handleChange = (value: DateTime<boolean> | null) => {
    props.onChange(value?.toISODate() ?? '');
  };
  const dateValue = props.value ? DateTime.fromISO(props.value) : undefined;
  return (
    <>
      <DatePicker
        label={props.label ?? undefined}
        onChange={handleChange}
        value={dateValue}
        disabled={props.disabled}
        sx={{
          m: 0,
          mt: 2,
          '.MuiInputBase-root': {
            py: '6px',
            px: 2,
          },
          ...props.sx,
        }}
        slotProps={{
          textField: {
            helperText: props.errorMessage,
            error: props.error,
          },
          openPickerButton: {
            'aria-label': t('chooseDate'),
          },
        }}
        inputRef={props.inputRef}
        minDate={props.minDate}
      />
    </>
  );
}
